'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /* eslint no-underscore-dangle:
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           ["error", { "allow": ["_parametersByName", "_parametersByType"] }]
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                         */

exports.createBaseRequest = createBaseRequest;
exports.search = search;

var _urlParse = require('url-parse');

var _urlParse2 = _interopRequireDefault(_urlParse);

var _formats = require('./formats');

var _utils = require('./utils');

var _error = require('./error');

var _config2 = require('./config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @module opensearch/search
 */

/**
 * @typedef module:opensearch/search.BaseRequest
 * @type Object
 * @property {string} url The URL of the search service.
 * @property {string} method The ussed HTTP method.
 * @property {object} [headers] Optional HTTP headers.
 * @property {string|FormData} [body] The body to be sent to the search service.
 *                                    (For HTTP POST requests)
 */

/**
 * Returns an object that can be transformed into a fetch Request or an
 * XMLHttpRequest.
 * @param {string} url The url to send the search request to.
 * @param {object} parameterValues The search parameter values.
 * @param {boolean} [options.dropEmptyParameters=false] Whether unused parameter keys shall
 *                                                      be dropped from the request.
 * @param {object} headers Additional headers to set on the request.
 * @returns {module:opensearch/search.BaseRequest} The constructed base request object.
 */
function createBaseRequest(url, parameterValues, dropEmptyParameters, headers) {
  // check parameters
  Object.keys(parameterValues).forEach(function (key) {
    if (!Object.prototype.hasOwnProperty.call(url._parametersByType, key) && !Object.prototype.hasOwnProperty.call(url._parametersByName, key)) {
      throw new Error('Invalid parameter \'' + key + '\'.');
    }
  });

  var missingMandatoryParameters = url.getMissingMandatoryParameters(parameterValues).map(function (parameter) {
    return parameter.type;
  });

  if (missingMandatoryParameters.length) {
    throw new Error('Missing mandatory parameters: ' + missingMandatoryParameters.join(', '));
  }

  // serialize the parameters
  var serialized = url.serializeValues(parameterValues);

  // depending on the request method, create the request 'body' or query string
  if (url.method === 'GET') {
    // insert parameters into URL template
    var urlString = url.url;

    for (var i = 0; i < serialized.length; ++i) {
      var _serialized$i = _slicedToArray(serialized[i], 3),
          type = _serialized$i[1],
          value = _serialized$i[2];

      urlString = urlString.replace(new RegExp('{' + type + '[?]?}'), value);
    }

    if (dropEmptyParameters) {
      var parsed = (0, _urlParse2.default)(urlString, false);
      var query = parsed.query.split('&').map(function (param) {
        return param.split('=');
      }).filter(function (paramParts) {
        return paramParts[1] !== '';
      }).map(function (paramParts) {
        return paramParts.join('=');
      }).join('&');

      parsed.set('query', query);
      urlString = parsed.toString();
    }

    return {
      method: url.method,
      url: urlString,
      headers: headers
    };
  }

  // for POST
  var enctype = url.enctype || 'application/x-www-form-urlencoded';
  var body = null;
  if (enctype === 'application/x-www-form-urlencoded') {
    body = serialized.map(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 3),
          name = _ref2[0],
          value = _ref2[2];

      return encodeURIComponent(name) + '=' + encodeURIComponent(value);
    }).join('&');
  } else if (enctype === 'multipart/form-data') {
    body = new FormData();
    serialized.forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 3),
          name = _ref4[0],
          value = _ref4[2];

      return body.append(name, value);
    });
  } else {
    throw new Error('Unsupported enctype \'' + enctype + '\'.');
  }

  return {
    method: url.method,
    url: url.url,
    headers: {
      'Content-Type': enctype
    },
    body: body
  };
}

/**
 * Performs a search for the given URL and parameters.
 * @param {OpenSearchUrl} url The URL to search on.
 * @param {object} [parameters={}] The search parameters.
 * @param {object} [options={}] Additional options.
 * @param {string} [options.type=null] The response format.
 * @param {boolean} [options.raw=false] Whether the response shall be parsed or returned raw.
 * @param {number} [options.maxUrlLength=undefined] The maximum URL length.
 *                                                  URLs longer than that
 *                                                  will result in errors.
 * @param {boolean} [options.dropEmptyParameters=false] Whether unused parameter keys shall
 *                                                      be dropped from the request.
 * @param {object} [options.parseOptions=undefined] Additional options for the format.
 * @param {object} [options.headers=undefined] Specific headers to send to the service.
 * @returns {Promise<SearchResult>|Promise<Response>} The search result as a Promise
 */
function search(url) {
  var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var type = options.type,
      raw = options.raw,
      maxUrlLength = options.maxUrlLength,
      dropEmptyParameters = options.dropEmptyParameters,
      parseOptions = options.parseOptions,
      headers = options.headers;


  var baseRequest = createBaseRequest(url, parameters, dropEmptyParameters, headers);

  var _config = (0, _config2.config)(),
      useXHR = _config.useXHR,
      Promise = _config.Promise;

  if (typeof maxUrlLength !== 'undefined' && baseRequest.url.length > maxUrlLength) {
    return Promise.reject(new Error('Search URL too long: ' + baseRequest.url.length + ', maximum: ' + maxUrlLength));
  }

  var request = null;

  // Decide whether to use XHR or fetch
  if (useXHR) {
    request = new Promise(function (resolve, reject, onCancel) {
      var xhr = (0, _utils.createXHR)(baseRequest.url, baseRequest);
      xhr.onload = function () {
        if (raw) {
          resolve(xhr);
        }
        resolve([xhr.responseText, xhr.status]);
      };

      xhr.onerror = function () {
        reject(new TypeError('Failed to fetch'));
      };

      // set up cancellation if available
      if (onCancel && typeof onCancel === 'function') {
        onCancel(function () {
          xhr.abort();
        });
      }
    });
  } else {
    // fetch API
    request = fetch((0, _utils.createRequest)(baseRequest.url, baseRequest));
    if (raw) {
      return request;
    }
    request = request.then(function (response) {
      return response.text().then(function (text) {
        return [text, response.status];
      });
    });
  }

  // postprocess, check for error and parse result
  return request.then(function (_ref5) {
    var _ref6 = _slicedToArray(_ref5, 2),
        text = _ref6[0],
        status = _ref6[1];

    if (status >= 400) {
      var error = (0, _error.getErrorFromXml)(text);
      throw error || new Error(text);
    }
    var format = (0, _formats.getFormat)(type || url.type);
    if (!format) {
      throw new Error('Could not parse response of type \'' + type + '\'.');
    }
    return format.parse(text, parseOptions);
  });
}


// WEBPACK FOOTER //
// /~/opensearch-browser/dist/search.js